module.exports = __webpack_public_path__ + "static/media/miniwave-policie-yellow.56c69af2.svg";